<div class="category-invoice-amount">
  <div class="chart" #chart>
    <i class="category-i" [ngClass]="categoryIcon"></i>
  </div>
  <div class="category-invoice-amount__content">
    <div class="title">{{ title | translate }}</div>
    <app-money-box [dataContext]="amount"></app-money-box>
  </div>
</div>
